import React, { useState, useEffect } from "react";

import Popup from "./Popup";
import { Search } from "react-feather";
import { CAvatar } from "@coreui/react";
import { useForm } from "react-hook-form";

import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";

import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";
import LoadingCenter from "./LoadingCenter";
import { useMutation } from "@tanstack/react-query";
import { useHttp } from "../hooks/useHttp";
import openToast from "../utils/sweetAlert";
import { formatAdminTransferLabel } from "../utils/porte";

const schema = yup.object({
  admin: yup.string().required("É necessário selecionar uma opção acima!").nullable()
}).required();

const PopupTransferDirOutdated = props => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const request = useHttp();
  const { customers } = props;
  const [search, setSearch] = useState("");
  const [admins, setResponse, loading, error, axiosFetch] = useAxiosFunction();

  useEffect(() => {
    if (customers) {
      axiosFetch({
        axiosInstance,
        method: "GET",
        url: "/admins/list?sales_only=1",
        redirect_to: ""
      });
    }
  }, [props.trigger === true]);

  const avatarStyle = avatarPicture => ({
    width: "45px",
    height: "45px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${avatarPicture})`
  });

  const filteredAdmins = search?.length > 0
    ? admins?.filter(admin => admin.name?.toLowerCase().includes(search.toLowerCase()))
    : admins;

  const transferMutation = useMutation(["transfer-customer"], ({ users, adminId }) => request({ url: "/users/transfer/dir", method: "POST", data: {
    users: users,
    admin_id: adminId
  }}), {
    onSuccess: res => {
      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
        props.setTrigger(!props.trigger);
      }

      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }
    },
    onError: error => {
      openToast("error", "Ocorreu um erro", error.response?.data?.message || "Não foi possível transferir os clientes.");
    }
  });

  const transferCustomers = data => {
    const newArr = customers.map(customer => customer.id);
    transferMutation.mutate({ users: newArr, adminId: data.admin });
  };

  return (
    <Popup title="Transferir clientes para um admin" trigger={props.trigger} setTrigger={props.setTrigger} width={400}>
      <form onSubmit={handleSubmit(transferCustomers)}>
        <div className="x-p-20 y-p-20">
          <div className="inner-search">
            <div className="search-icon">
              <Search size={24} />
            </div>

            <input className="search-input" type="text" placeholder="Pesquisar"
              onChange={e => setSearch(e.target.value)} value={search} />
          </div>
        </div>

        <div>
          <ul className="contact__list">
            {loading && <LoadingCenter />}

            {!loading && admins?.length <= 0 && <div className="x-p-20 y-p-10">Não foram encontrados registros.</div>}

            {!loading && customers?.length > 0 && <div className="x-p-20 y-p-10 text-color">{customers?.length} contatos selecionados.</div>}

            {!loading && admins?.length > 0 && filteredAdmins.map(admin => {
              return (
                <label key={admin.id} className="contact__item x-p-20 y-p-10 d-flex flex-row align-center">
                  <div className="mr-20">
                    <input className="radio__btn" type="radio" name="admin" value={admin.id} {...register("admin")} />
                  </div>

                  <div className="mr-10">
                    <CAvatar color="light" textColor="dark" style={avatarStyle(admin.profile_picture)} />
                  </div>

                  <span className="text-color">{formatAdminTransferLabel(admin)}</span>
                </label>
              );
            })}

            {errors.admin && <div className="x-p-20 y-p-20 mp-0 text-error">{errors.admin.message}</div>}

          </ul>
        </div>

        {!loading && <div className="popup-footer x-p-20 y-p-20">
          <button className="btn btn-primary" type="submit" disabled={transferMutation.isLoading}>
            {transferMutation.isLoading ? "Carregando..." : "Enviar"}
          </button>
          <button className="btn btn-light mr-20" type="button" onClick={() => props.setTrigger(false)}>Cancelar</button>
        </div>}
      </form>
    </Popup >
  );
}

export default PopupTransferDirOutdated;
